// Module
var code = "<div> <img view=\"Image\" data-route=\"asset\" data-preset=\"original\" data-file_name=\"[[image.file_name]]\" data-ext=\"[[ image.ext ]]\"/> </div> ";
// Exports
export default code;